<div class="navigation-result-empty">
    <app-fn-ui-empty-icon></app-fn-ui-empty-icon>
    <div class="message">{{ message | translate }}</div>
</div>